import { z } from 'zod';
export const DeviceId = z.string().regex(/^\d{9}$/, 'ID do dispositivo deve ter 9 dígitos');
export const SessionId = z.string().uuid();
export const SessionRole = z.enum(['host', 'viewer']);
export const SessionStatus = z.enum(['pending', 'active', 'rejected', 'ended', 'expired']);
export const SessionEndReason = z.enum([
    'host_ended',
    'viewer_ended',
    'host_offline',
    'viewer_offline',
    'expired',
    'server_shutdown',
    /** A empresa retirou a permissão (colaborador removido, acesso alterado, dispositivo desvinculado). */
    'access_revoked',
]);
export const IceServer = z.object({
    urls: z.array(z.string().min(1)).min(1),
    username: z.string().optional(),
    credential: z.string().optional(),
});
/** Formata o ID em grupos de 3 dígitos para exibição (123 456 789). */
export function formatDeviceId(id) {
    return id.replace(/(\d{3})(?=\d)/g, '$1 ');
}
/** Remove espaços/traços digitados pelo usuário. */
export function normalizeDeviceId(raw) {
    return raw.replace(/[\s-]/g, '');
}
//# sourceMappingURL=session.js.map